export default {
  CLOSED: "closed",
  OPENED: "opened",
  CLOSE: "close",
  OPEN: "open",
  SEARCH: "Search",
  FILTER: "filter",
  NOT_FOUND: "No manager found",
};
